import React from "react";
import { ReactComponent as InternalServerError } from "../../../Assets/ErrorPage/InternalServerError.svg";

const InternalServerErrorPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <InternalServerError className="w-60 h-60 text-gray-400" />

      <h1 className="text-6xl font-bold text-red-600 mb-4">500</h1>
      <h2 className="text-2xl font-semibold text-gray-800 mb-2">Internal Server Error</h2>
      <p className="text-gray-600 max-w-md text-center mb-6">
        Oops! Something went wrong on our end. We’re already working on it. Please try again later
        or go back to our homepage.
      </p>
      <p className="text-gray-600 max-w-md text-center mb-6">
        You can also contact our support team at{" "}
        <a href="mailto:support@zomentum.com" className="text-blue-600 hover:underline">
          support@zomentum.com
        </a>
      </p>

      <a
        href="/"
        className="px-6 py-3 text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200"
      >
        Go to Homepage
      </a>
    </div>
  );
};

export default InternalServerErrorPage;
